import { IStampable, ToolType } from "../../types/Floorplan.types";
import { createDoorSvg } from "./SvgElements";

export interface IDoorsProps {
    doors?: IStampable[];
    selectedDoorIdx?: number;
    selectedTool?: ToolType;
}

const Desks = (props: IDoorsProps) => {
    const { doors, selectedDoorIdx, selectedTool } = props;
    if (doors && doors.length > 0) {
        return (
            <g id="doors">
                { doors.map((door, idx) => {
                    const svg = createDoorSvg();
                    const html = svg.innerHTML;
                    let cursor: string | undefined = undefined, transform: string | undefined = undefined;
                    let className = "door door-" + idx;
                    if (selectedTool === "Pointer" && selectedDoorIdx === idx) {
                        className = "draggable draggableDoor-" + idx;
                    }
                    if (door.rotation !== 0) {
                        transform = `rotate(${door.rotation}, 10, 12)`;
                    }
                    
                    return (
                        <svg key={`door_${idx}`} data-idx={idx} className={className} pointerEvents="all" style={{cursor}} x={door.x} y={door.y} overflow="visible">
                            <g transform={transform} dangerouslySetInnerHTML={{__html: html}}></g>
                        </svg>
                    );
                }) }
            </g>
        );
    }
    return null;
};

export default Desks;